import { start } from "repl";
import { setProposalsSuccessful,setProposalsFailed} from "./reducer";
import axiosInstance from "src/common/axiosInstance";

export const getProposals: any = (
    client_id: any, 
    agency_id: any, 
    startdate: Date, 
    enddate: Date, 
    sortField?: string,
    sortDirection?: 'asc' | 'desc',
    history?: any
) => async (dispatch: any) => {
    try {
        const response = await axiosInstance.get('/proposals', {
            params: {
                client_id: client_id,
                agency_id: agency_id,
                start_date: startdate,
                end_date: enddate,
                sort_field: sortField || '',
                sort_direction: sortDirection || 'asc'
            },
        });
        const data = await response.data;
        if (data) {
            dispatch(setProposalsSuccessful(data));
        }
    } catch (error) {
        dispatch(setProposalsFailed(error));
    }
};
